import { render, staticRenderFns } from "./ClientMedRecords.vue?vue&type=template&id=2c853ac1"
import script from "./ClientMedRecords.vue?vue&type=script&lang=js"
export * from "./ClientMedRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports